module.exports = __webpack_public_path__ + "img/p65-wenzhou-2008.cffa2672.jpg";